import service from './service';

export const findAll = listQuery => {
  return service.get('/v1/quota', listQuery);
};

export const findOne = id => {
  return service.get(`/v1/quota/${id}`);
};

export const update = (id, data) => {
  return service.post(`/v1/quota/${id}`, data);
};

export const create = (quota, quotaDetail) => {
  return service.post(`/v1/quota`, { quota, quotaDetail });
};

export const verify = id => {
  return service.post(`/v1/quota/${id}/verify`);
};

export const sendEmail = id => {
  return service.post(`/v1/quota/${id}/send`);
};

export const removeList = list => {
  return service.post(`/v1/quota/deletes`, { list });
};

export const history = ({ limit, page, productId, specId, color, customerId, reasonId, length }) => {
  return service.get('/v1/quota/history/list', {
    limit,
    page,
    productId,
    specId,
    color,
    customerId,
    reasonId,
    length
  });
};
